import { VariableBenefitDestinationJurisdictionDetail } from './variable-benefit-destination-jurisdiction-detail';
import { Deserializable } from '../protocols/deserializable';
import { SpousalWaiverAttachment } from './spousal-waiver-attachment';

export class UpdateVariableBenefitGoverningJurisdictionDetail
  extends VariableBenefitDestinationJurisdictionDetail
  implements Deserializable
{
  public submissionSpousalWaivers: SpousalWaiverAttachment[] = [];
  public memberSpousalWaivers: SpousalWaiverAttachment[] = [];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    super.onDeserialize();
    if (this.submissionSpousalWaivers?.length > 0) {
      this.submissionSpousalWaivers = Deserialize.arrayOf(SpousalWaiverAttachment, this.submissionSpousalWaivers);
    }

    if (this.memberSpousalWaivers?.length > 0) {
      this.memberSpousalWaivers = Deserialize.arrayOf(SpousalWaiverAttachment, this.memberSpousalWaivers);
    }
  }
}
